import * as React from "react"
import { cn } from "src/lib/utils"

const buttonVariants = (props) => {
  const baseClasses = "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-walme-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50"

  const variant = props.variant || "default"
  const size = props.size || "default"

  const variantClasses = {
    default: "bg-walme-primary text-walme-bg hover:bg-walme-primary-hover hover:shadow-lg hover:shadow-walme-primary/30 hover:-translate-y-0.5",
    destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
    outline: "border border-walme-border bg-transparent hover:bg-walme-bg-elevated hover:border-walme-border-hover text-walme-text",
    secondary: "bg-walme-bg-elevated text-walme-text hover:bg-walme-bg-elevated-2",
    ghost: "hover:bg-walme-bg-elevated hover:text-walme-text text-walme-text-dim",
    link: "text-walme-primary underline-offset-4 hover:underline",
  }

  const sizeClasses = {
    default: "h-10 px-4 py-2",
    sm: "h-9 rounded-md px-3 text-xs",
    lg: "h-12 rounded-lg px-8 text-base",
    icon: "h-10 w-10",
  }

  return cn(baseClasses, variantClasses[variant], sizeClasses[size], props.className)
}

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => {
  return (
    <button
      className={buttonVariants({ variant, size, className })}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
